import React from 'react';
import ImageUploader from './ImageUploader';

const ListEditor = ({ label, items, onChange, emptyItem, fields }) => {
  const handleAdd = () => {
    onChange([...(items || []), { ...emptyItem }]);
  };

  const handleRemove = (index) => {
    const next = (items || []).filter((_, idx) => idx !== index);
    onChange(next);
  };

  const handleFieldChange = (index, fieldName, value) => {
    const next = (items || []).map((item, idx) => (idx === index ? { ...item, [fieldName]: value } : item));
    onChange(next);
  };

  const handleMove = (index, direction) => {
    const list = items || [];
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= list.length) {
      return;
    }
    const next = [...list];
    const temp = next[index];
    next[index] = next[targetIndex];
    next[targetIndex] = temp;
    onChange(next);
  };

  return (
    <div className="list-editor">
      <div className="list-editor-header">
        <h3>{label}</h3>
        <button type="button" className="add-btn" onClick={handleAdd}>
          + Add
        </button>
      </div>

      <div className="list-editor-items">
        {(items || []).length === 0 && <p>No entries yet.</p>}
        {(items || []).map((item, index) => (
          <div className="list-editor-item" key={`${label}-${index}`}>
            {fields.map((field) => {
              const value = item[field.name] ?? '';
              const handleValueChange = (nextValue) => handleFieldChange(index, field.name, nextValue);
              let control = null;

              if (field.type === 'textarea') {
                control = (
                  <textarea
                    value={value}
                    rows={field.rows || 3}
                    placeholder={field.placeholder}
                    onChange={(event) => handleValueChange(event.target.value)}
                  />
                );
              } else if (field.type === 'image') {
                control = (
                  <ImageUploader
                    value={value}
                    onChange={(url) => handleValueChange(url)}
                    helperText={field.helperText}
                  />
                );
              } else {
                const inputProps = {
                  value,
                  placeholder: field.placeholder,
                  onChange: (event) => handleValueChange(event.target.value)
                };

                if (field.type === 'number') {
                  inputProps.type = 'number';
                  if (typeof field.min !== 'undefined') inputProps.min = field.min;
                  if (typeof field.max !== 'undefined') inputProps.max = field.max;
                  if (typeof field.step !== 'undefined') inputProps.step = field.step;
                } else if (field.inputType) {
                  inputProps.type = field.inputType;
                }

                control = <input {...inputProps} />;
              }

              return (
                <div className="form-group" key={field.name}>
                  <label>{field.label}</label>
                  {control}
                  {field.helperText && field.type !== 'image' && (
                    <p className="field-hint">{field.helperText}</p>
                  )}
                </div>
              );
            })}
            <div className="list-editor-controls">
              <div className="order-controls">
                <button
                  type="button"
                  className="order-btn"
                  onClick={() => handleMove(index, -1)}
                  disabled={index === 0}
                  aria-label="Move up"
                >
                  ↑
                </button>
                <button
                  type="button"
                  className="order-btn"
                  onClick={() => handleMove(index, 1)}
                  disabled={index === (items || []).length - 1}
                  aria-label="Move down"
                >
                  ↓
                </button>
                <span className="order-index">#{index + 1}</span>
              </div>
              <button type="button" className="remove-btn" onClick={() => handleRemove(index)}>
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListEditor;
